import { ThunkAction, ThunkDispatch } from "redux-thunk";
import * as storeTypes from "../storeTypes";
import * as frontService from "../../services/frontService";
import { handleApiError } from "../storeEffects";
import { FrontAction, frontFailure, frontSuccess } from "./storeFront";

export type FrontThunkDispatch = ThunkDispatch<storeTypes.IApplicationState, null, FrontAction>

export const getFront = (): ThunkAction<any, storeTypes.IApplicationState, any, any> => (dispatch, getState) => {
    //dispatch(storeActions.fetchStart());
    return frontService.getFrontPage()
        .then(
            front => {
                dispatch(frontSuccess(front));
            },
            error => {
                handleApiError(error, dispatch);
                dispatch(frontFailure());
            })
        .finally(
            //() => dispatch(storeActions.fetchEnd())
        );
};